import {EnvironmentsInterface} from "../app/types/environments/environments.interface";

export const environment: EnvironmentsInterface = {
  production: false,
  stage: true,
  apiUrl: 'https://api.dallepd.ovdal.dk/api',
  backendUrl: 'https://api.dallepd.ovdal.dk',
  apiKey: 'd23208b615a7366adfa3c1c1e108b3e5f6eba4226aeb45efb5353cfefbc76226d63b1870b6939ebaab6dbae0a0cdca9550e8a18cd41aff46e12695b5c2b16c633b67a402ed5b67c859fa7706bc9157b49ca9042da59bfe108ef48a353872dca067d32cb2629285d4c80816b3053582c64b04f17cf266a423c5ae3137f8d6407e',
  hostName: 'https://dallepd.ovdal.dk',
  localImagePath: 'assets/img',
  jwtAllowedDomains: 'api.dallepd.ovdal.dk',
  disallowedRoutes_1: 'https://api.dallepd.ovdal.dk/auth/local',
  disallowedRoutes_2: 'https://api.dallepd.ovdal.dk/auth/local/register',
}
